import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

function Card({ className, children, ...props }: ComponentProps<"div">) {
  return (
    <div
      className={twMerge("block w-full bg-white rounded shadow", className)}
      {...props}
    >
      {children}
    </div>
  );
}
function CardHeader({ className, children, ...props }: ComponentProps<"div">) {
  return (
    <div
      className={twMerge("w-full border-b border-[#e8eaee] p-4", className)}
      {...props}
    >
      {children}
    </div>
  );
}
function CardBody({ className, children, ...props }: ComponentProps<"div">) {
  return (
    <div className={twMerge("w-full p-4", className)} {...props}>
      {children}
    </div>
  );
}
function CardFooter({ className, children, ...props }: ComponentProps<"div">) {
  return (
    <div
      className={twMerge("w-full border-t border-[#e8eaee] p-4", className)}
      {...props}
    >
      {children}
    </div>
  );
}

Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;

export default Card;
